import { useTranslation } from "react-i18next";
import { IOrder } from "../interfaces/IOrder";
import FullscreenImage from "./general/FullScreenImage";

interface IOrderPhotosSectionProps {
  order: IOrder;
}

export default function OrderPhotosSection({
  order,
}: IOrderPhotosSectionProps) {
  const { t } = useTranslation();

  return (
    <div>
      <h4
        className="h4"
        style={{
          marginBottom: "var(--md)",
        }}
      >
        {t("v2.OrderPage.imagesSection.title")}
      </h4>
      <div className="images-grid">
        {order.orderPhotos?.map((item, i) => (
          <FullscreenImage
            key={i}
            style={{
              width: "100%",
              //   maxWidth: 300,
              aspectRatio: "1/1",
              borderRadius: 20,
              objectFit: "cover",
              boxShadow: "var(--sh) !important",
            }}
            alt="Imagine"
            src={item.s3Url}
          />
        ))}
      </div>
    </div>
  );
}
